module.exports = __webpack_public_path__ + "static/img/SSHA_V.4ff1b72.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/shipIcons/oceantool/SSHA_V.png
// module id = 8WI6
// module chunks = 18